<template>
  <div class="bg-block shadow-primaryBlock rounded
  px-6 py-8 lg:px-12 lg:py-13 mb-8 lg:mb-12">
    <MyAccountsTitle :dirty="accounts.dirty || account_groups.dirty"
                     :balance="spaceBalance"/>
    <div class="lg:-mx-6">
      <MyAccountsLoadingRows v-if="accounts.dirty || account_groups.dirty"/>
      <MyAccountsGroupedRows v-else-if="displayAccountsInGroups && !!accounts.data.length"
                             @toggleGroup="toggleGroup($event)"
                             :groups="accounts_by_groups_not_hidden"
                             @selectAcc="setSelectedAcc($event)"/>
      <MyAccountsItemsRows v-else-if="!displayAccountsInGroups && !!accounts.data.length"
                           class="text-text-gray divide-y divide-bg rounded overflow-hidden"
                           :accounts="accounts_not_hidden"
                           @selectAcc="setSelectedAcc($event)"/>
      <div class="text-sm text-text text-center mb-5 p-2" v-else>
        У вас нет активных счетов
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import MyAccountsTitle from "@/components/cabinet/Money/Dashboard/MyAccounts/MyAccountsTitle";
import MyAccountsLoadingRows from "@/components/cabinet/Money/Dashboard/MyAccounts/MyAccountsLoadingRows";
import MyAccountsItem from "@/components/cabinet/Money/Dashboard/MyAccounts/MyAccountsItem";
import MyAccountsGroupedRows from "@/components/cabinet/Money/Dashboard/MyAccounts/MyAccountsGroupedRows";
import MyAccountsItemsRows from "@/components/cabinet/Money/Dashboard/MyAccounts/MyAccountsItemsRows";

export default {
  name: "MyAccounts",
  components: {
    MyAccountsTitle,
    MyAccountsItem,
    MyAccountsLoadingRows,
    MyAccountsItemsRows,
    MyAccountsGroupedRows,
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('space/accounts', ['accounts', 'account_groups']),
    ...mapState('cabinet/currencies', ['currencies']),
    ...mapGetters('space/accounts', ['accounts_not_hidden', 'accounts_by_groups_not_hidden', 'accounts_balance', 'displayAccountsInGroups']),
    spaceBalance() {
      if (this.account_groups.data.length > 0) {
        return `${this.accounts_balance} ${this.currencies.filter(i => i.id === this.current_space.data.currency_id)[0].symbol}`
      } else {
        return ''
      }
    },
  },
  methods: {
    ...mapMutations('space/accounts', ['setGroupVisibility']),
    ...mapMutations('moneyDashboard/recentTransactions', ['setSelectedAcc']),
    toggleGroup(acc_group) {
      let newVal = !acc_group.dashboard_collapsed;
      this.setGroupVisibility({id: acc_group.id, state: newVal})
    }
  }
}
</script>
